import { useNotification } from '../common/NotificationContext';


export const useSnackbarNotification = () => {
  const showSnackbar = useNotification();
  return { showSnackbar };
};